import { render, staticRenderFns } from "./suggestdiv.vue?vue&type=template&id=0d9a2174&scoped=true&"
import script from "./suggestdiv.vue?vue&type=script&lang=js&"
export * from "./suggestdiv.vue?vue&type=script&lang=js&"
import style0 from "./suggestdiv.vue?vue&type=style&index=0&id=0d9a2174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9a2174",
  null
  
)

export default component.exports